import { computed } from "vue";
import { useStore } from "vuex";

import type { RootState } from "@/store/types";
import { TemplateType } from "shared-utils/enums/masterTemplate";
import { EditorGetters } from "@/store/modules/editor";

export function useEditor() {
    const store = useStore<RootState>();

    const editables = computed(() => store.state.campaign.normalized.editables);
    const editedEditable = computed(() => store.state.editor.editedEditable);
    const editable = computed(() => editedEditable.value && editables.value[editedEditable.value.editable._id]);

    const selectedGroupValues = computed(
        () => store.state.editor.selectedGroupValues as Record<string, { groupName: string; groupValueId: string }>
    );
    const selectedGroupValuesIds = computed(() => store.state.editor.selectedGroupValueIds);
    const selectedLanguage = computed(() => store.state.editor.selectedLanguage);

    const campaignType = computed(() => store.state.campaign.campaignType ?? TemplateType.HTML5);
    const isCampaignPSD = computed(() => campaignType.value === TemplateType.PSD);
    const isCampaignAE = computed(() => campaignType.value === TemplateType.AE);
    const isCampaignIndesign = computed(() => campaignType.value === TemplateType.INDESIGN);

    const fonts = computed(() => store.state.editor.fonts);
    const fontIds = computed(() => (store.getters as Record<string, unknown>)[EditorGetters.fontIds] as string[]);

    return {
        editables,
        editedEditable,
        editable,

        isCampaignPSD,
        isCampaignAE,
        isCampaignIndesign,

        selectedGroupValues,
        selectedGroupValuesIds,
        selectedLanguage,

        fonts,
        fontIds
    };
}
